'use strict'

function initializeHeroNav() {
  $(document).ready(function(){
    //Click event for hero mobile navigation
    $('.hero__nav-list').click(function(e){
      console.log($(this))
      console.log(e)
      if ($(e.target).is("a, i") && $(this).parents('.teaser-card__external-link')) {
        // e.preventDefault();
        // e.stopPropagation();
      } else {
        e.preventDefault()
        $(this).toggleClass('hero__nav-list--open')
      }
    });
  });
}

export default initializeHeroNav
